import { loaders } from './../constants'
import axios, { microServices } from './axios'

// // ********************API url *******************
const GET_INVENTORY_LIST = '/inventory/items'
const GET_ITEMS = '/inventory/items'
const GET_INVENTORY_ITEMS = '/inventory/item-list'
const LIST_INVENTORY = '/inventory/list'
const LIST_INVENTORY_DUPLICATES = '/inventory/list/duplicates'
const UPDATE_STOCK = '/inventory/items/stock'
const SAVE_ITEM = '/inventory/item'
const MOVE_ITEMS = '/inventory/move-items'
const SAVE_BULK_ITEM = '/inventory/item/bulk'
const UPDATE_BULK_ITEM = '/inventory/item-bulk'
const GET_CATEGORIES = '/inventory/categories'
const LIST_CATEGORIES = '/inventory/categories/list'
const LIST_TEMPLATE_CATEGORIES = '/inventory/template/categories/list'
const SAVE_CATEGORY = '/inventory/category'
const GET_VENDOR_CATEGORIES = '/inventory/vendorcategory'
const CHECK_MATERIAL_USAGE = '/inventory/check-material-usage'
const ADD_LABOR_SKILL = 'inventory/labor'
const DEL_LABOR_SKILL = 'inventory/labor'
const GET_LABORS = 'inventory/labors'
const SAVE_LEVEL = 'level/'
const GET_LEVELS_LIST = 'level/list'
const UNITS = '/unit'
const GET_TRANSACTIONS_LIST = '/inventory/transactions'
const ADD_NO_PO_STOCK = '/inventory/add-no-po-stock'
const UPDATE_DUPLICATE_VISIBILITY = '/inventory/item/duplicates/visibility';
const SUGGEST_MATERIALS = '/inventory/item/suggestions';
const COUNT_AFFECTED_TEMPLATES = '/inventory/item-templates/count-affected';
const MASS_REPLACE_MATERIALS = '/inventory/item-templates/mass-replace';
const REPLACE_AND_HIDE_MATERIALS = '/inventory/item-templates/replace-and-hide';
const SWAP_MATERIALS = '/inventory/materials/swap';
const GET_SWAP_AFFECTED_COUNT = '/inventory/materials/swap/affected-count';
const GET_SWAP_MATERIALS_LIST = '/inventory/materials/swap/list';
const GET_INVENTORY_COUNTS = '/inventory/counts';
// // ************API call Functions starts here **************

export const getInventoryList = async () => {
  return await axios('get', GET_INVENTORY_LIST, {}, { server: microServices.DE_CORE }).then(data => {
    return data
  },
    error => { // request level error
      return new Promise((resolve, reject) => {
        reject(error)
      })
    })
}


export const deleteCategory = async ({ itemId, categoryId = '' }) => {
  return await axios('delete', `${SAVE_CATEGORY}/${itemId}/${categoryId}`, {}, { successMessage: 'Category Deleted Successfully', server: microServices.DE_CORE }).then(data => {
    return data
  },
    error => { // request level error
      return new Promise((resolve, reject) => {
        reject(error)
      })
    })
}

export const deleteLevel = async (itemId) => {
  return await axios('delete', `${SAVE_LEVEL}/${itemId}`, {}, { successMessage: 'Level Deleted Successfully', server: microServices.DE_CORE }).then(data => {
    return data
  },
    error => { // request level error
      return new Promise((resolve, reject) => {
        reject(error)
      })
    })
}

export const getLevels = async ({ sortBy = '' }) => {
  return await axios('get', `${GET_LEVELS_LIST}`, {}, {
    server: microServices.DE_CORE,
    params: {
      ...(sortBy ? { sortBy } : {})
    }
  }).then(data => data)
    .catch(error => Promise.reject(error));
};

export const getLevel = async (id, allLabors) => {
  return await axios('get', `${SAVE_LEVEL}`, {}, {
    server: microServices.DE_CORE,
    params: {
      ...(id ? { id } : {}),
      ...(allLabors ? { allLabors: true } : {})
    }
  }).then(data => {
    return data
  },
    error => { // request level error
      return new Promise((resolve, reject) => {
        reject(error)
      })
    })
}

export const getItems = async (params) => {
  const { categoryId, limit, offset, search } = typeof params === 'object' ? params : { categoryId: params };
  return await axios('get', `${GET_ITEMS}`, {}, {
    server: microServices.DE_CORE,
    params: {
      ...(categoryId ? { categoryId } : {}),
      ...(limit ? { limit } : {}),
      ...(offset !== undefined ? { offset } : {}),
      ...(search ? { search } : {}),
    }
  }).then(data => {
    return data
  },
    error => { // request level error
      return new Promise((resolve, reject) => {
        reject(error)
      })
    })
}

export const getInventoryItems = async (params = {}) => {
  const { offset, limit, categoryId, search, categoryFilter, manufacturerFilter, partNoFilter, sortBy } = params;
  return await axios('get', `${GET_INVENTORY_ITEMS}`, {}, {
    server: microServices.DE_CORE,
    params: {
      ...(categoryId ? { categoryId } : {}),
      ...(limit ? { limit } : {}),
      ...(offset !== undefined ? { offset } : {}),
      ...(search ? { search } : {}),
      ...(categoryFilter ? { categoryFilter } : {}),
      ...(manufacturerFilter ? { manufacturerFilter } : {}),
      ...(partNoFilter ? { partNoFilter } : {}),
      ...(sortBy ? { sortBy } : {}),
    }
  }).then(data => {
    return data
  },
    error => { // request level error
      return new Promise((resolve, reject) => {
        reject(error)
      })
    })
}

export const getCategories = async (categoryFilter = []) => {
  return await axios('get', GET_CATEGORIES, {}, {
    server: microServices.DE_CORE, loader: loaders.OVERLAY, params: {
      ...(categoryFilter ? { categoryFilter } : {})
    }
  }).then(data => {
    return data
  },
    error => { // request level error
      return new Promise((resolve, reject) => {
        reject(error)
      })
    })
}

export const listCategories = async ({ categoryFilter = [], sortBy = "" }) => {
  return await axios('get', LIST_CATEGORIES, {}, {
    server: microServices.DE_CORE,
    loader: loaders.OVERLAY,
    params: {
      ...(categoryFilter.length ? { categoryFilter } : {}),
      ...(sortBy ? { sortBy } : {})
    }
  }).then(data => data)
    .catch(error => Promise.reject(error));
};

export const listTemplateCategories = async (categoryFilter = []) => {
  return await axios('get', LIST_TEMPLATE_CATEGORIES, {}, {
    server: microServices.DE_CORE, loader: loaders.OVERLAY
  }).then(data => {
    return data
  },
    error => { // request level error
      return new Promise((resolve, reject) => {
        reject(error)
      })
    })
}
export const getVendorCategories = async (id) => {
  return await axios('get', `${GET_VENDOR_CATEGORIES}/${id}`, {}, { server: microServices.DE_CORE }).then(data => {
    return data
  },
    error => { // request level error
      return new Promise((resolve, reject) => {
        reject(error)
      })
    })
}

export const addItem = async (data) => {
  return await axios('post', SAVE_ITEM, data, { successMessage: 'Item Created Successfully', server: microServices.DE_CORE }).then(data => {
    return data
  },
    error => { // request level error
      return new Promise((resolve, reject) => {
        reject(error)
      })
    })
}

export const addBulkItem = async (data, configs = {}) => {
  return await axios('post', SAVE_BULK_ITEM, data, {
    server: microServices.DE_CORE,
    ...configs
  }).then(data => {
    return data
  },
    error => { // request level error
      return new Promise((resolve, reject) => {
        reject(error)
      })
    })
}

export const updateBulkItems = async (data, configs = {}) => {
  return await axios('put', UPDATE_BULK_ITEM, data, {
    loader: loaders.OVERLAY, successMessage: 'Items Updated Successfully', server: microServices.DE_CORE,
    ...configs
  }).then(data => {
    return data
  },
    error => { // request level error
      return new Promise((resolve, reject) => {
        reject(error)
      })
    })
}

export const checkMaterialUsage = async (materials, options) => {
  return await axios('post', CHECK_MATERIAL_USAGE, { materials, options }, { server: microServices.DE_CORE })
    .then(data => {
      return data
    },
      error => {
        return Promise.reject(error);
      }
    );
}

export const editItem = async (data, itemId) => {
  return await axios('put', `${SAVE_ITEM}/${itemId}`, data, { loader: loaders.OVERLAY, successMessage: 'Item Updated Successfully', server: microServices.DE_CORE }).then(data => {
    return data
  },
    error => { // request level error
      return new Promise((resolve, reject) => {
        reject(error)
      })
    })
}

export const updateLevel = async (data, itemId) => {
  return await axios('put', `${SAVE_LEVEL}/${itemId}`, data, { loader: loaders.OVERLAY, successMessage: 'Level Updated Successfully', server: microServices.DE_CORE }).then(data => {
    return data
  },
    error => { // request level error
      return new Promise((resolve, reject) => {
        reject(error)
      })
    })
}

export const updateCategory = async (data, itemId) => {
  return await axios('put', `${SAVE_CATEGORY}/${itemId}`, data, { successMessage: 'Category Updated Successfully', server: microServices.DE_CORE }).then(data => {
    return data
  },
    error => { // request level error
      return new Promise((resolve, reject) => {
        reject(error)
      })
    })
}

export const getItem = async (itemId) => {
  return await axios('get', `${SAVE_ITEM}/${itemId}`, {}, { server: microServices.DE_CORE }).then(data => {
    return data
  },
    error => { // request level error
      return new Promise((resolve, reject) => {
        reject(error)
      })
    })
}

export const deleteItem = async (itemId) => {
  return await axios('delete', `${SAVE_ITEM}/${itemId}`, {}, { successMessage: 'Item Deleted Successfully', server: microServices.DE_CORE }).then(data => {
    return data
  },
    error => { // request level error
      return new Promise((resolve, reject) => {
        reject(error)
      })
    })
}

export const addCategory = async (data) => {
  return await axios('post', SAVE_CATEGORY, data, { successMessage: 'Category Created Successfully', server: microServices.DE_CORE }).then(data => {
    return data
  },
    error => { // request level error
      return new Promise((resolve, reject) => {
        reject(error)
      })
    })
}

export const addLevel = async (data) => {
  return await axios('post', SAVE_LEVEL, data, { successMessage: 'Level Created Successfully', server: microServices.DE_CORE }).then(data => {
    return data
  },
    error => { // request level error
      return new Promise((resolve, reject) => {
        reject(error)
      })
    })
}

export const getLaborList = async (params = {}) => {
  return await axios('get', GET_LABORS, {}, {
    server: microServices.DE_CORE,
    params
  }).then(data => {
    return data;
  }, error => {
    return new Promise((resolve, reject) => {
      reject(error);
    });
  });
};
export const addLabor = async (data) => {
  return await axios('post', ADD_LABOR_SKILL, data, { successMessage: 'Skill Added Successfully', server: microServices.DE_CORE }).then(data => {
    return data
  },
    error => { // request level error
      return new Promise((resolve, reject) => {
        reject(error)
      })
    })
}

export const editLabor = async (data, itemId, options = {}) => {
  let config = { successMessage: 'Skill Updated Successfully', server: microServices.DE_CORE };
  if (!options.hideLoader) {
    config.loader = loaders.OVERLAY;
  }

  if (options.hideMessage) {
    delete config.successMessage;
  }

  return await axios('put', `${ADD_LABOR_SKILL}/${itemId}`, data, config).then(data => {
    return data
  },
    error => { // request level error
      return new Promise((resolve, reject) => {
        reject(error)
      })
    })
}

export const getLabor = async (itemId) => {
  return await axios('get', `${ADD_LABOR_SKILL}/${itemId}`, {}, { server: microServices.DE_CORE }).then(data => {
    return data
  },
    error => { // request level error
      return new Promise((resolve, reject) => {
        reject(error)
      })
    })
}

export const deleteLabor = async (itemId) => {
  return await axios('delete', `${DEL_LABOR_SKILL}/${itemId}`, {}, { successMessage: 'Skill Deleted Successfully', server: microServices.DE_CORE }).then(data => {
    return data
  },
    error => { // request level error
      return new Promise((resolve, reject) => {
        reject(error)
      })
    })
}

export const getLabors = async (id) => {
  return await axios('get', GET_LABORS, {}, { server: microServices.DE_CORE }).then(data => {
    return data
  },
    error => { // request level error
      return new Promise((resolve, reject) => {
        reject(error)
      })
    })
}

export const saveUnits = async (data) => {
  return await axios('post', UNITS, data, { successMessage: 'Units Saved Successfully', server: microServices.DE_CORE }).then(data => {
    return data
  },
    error => { // request level error
      return new Promise((resolve, reject) => {
        reject(error)
      })
    })
}

export const getUnits = async ({ sortBy = '' }) => {
  return await axios('get', UNITS, {}, {
    server: microServices.DE_CORE, params: {
      ...(sortBy ? { sortBy } : {})
    }
  }).then(data => {
    return data
  },
    error => { // request level error
      return new Promise((resolve, reject) => {
        reject(error)
      })
    })
}

export const updateItemStock = async (data) => {
  return await axios('put', UPDATE_STOCK, data, { loader: loaders.OVERLAY, successMessage: 'DE Stock Updated Successfully', server: microServices.DE_CORE }).then(data => {
    return data
  },
    error => { // request level error
      return new Promise((resolve, reject) => {
        reject(error)
      })
    })
}

export const getTransactionsList = async (params = {}) => {
  const { location, poId, itemId, limit, offset, search } = params;
  return await axios('get', `${GET_TRANSACTIONS_LIST}`,
    {}, {
    server: microServices.DE_CORE,
    params: {
      ...(location ? { location } : {}),
      ...(poId ? { poId } : {}),
      ...(itemId ? { itemId } : {}),
      ...(limit ? { limit } : {}),
      ...(offset !== undefined ? { offset } : {}),
      ...(search ? { search } : {}),
    }
  }).then(data => {
    return data
  },
    error => { // request level error
      return new Promise((resolve, reject) => {
        reject(error)
      })
    })
}

export const getInventoryCounts = async (params = {}) => {
  const { categoryId, search, categoryFilter, manufacturerFilter, partNoFilter } = params;
  // Fetch inventory counts for tabs
  return await axios('get', GET_INVENTORY_COUNTS,
    {}, {
    server: microServices.DE_CORE,
    params: {
      ...(categoryId ? { categoryId } : {}),
      ...(search ? { search } : {}),
      ...(categoryFilter ? { categoryFilter } : {}),
      ...(manufacturerFilter ? { manufacturerFilter } : {}),
      ...(partNoFilter ? { partNoFilter } : {}),
    }
  }).then(data => {
    return data
  },
    error => { // request level error
      return new Promise((resolve, reject) => {
        reject(error)
      })
    })
}



export const addNoPoStock = async (data) => {
  return await axios('put', ADD_NO_PO_STOCK, data,
    {
      loader: loaders.OVERLAY,
      successMessage: ' Stock Updated Successfully',
      server: microServices.DE_CORE
    }).then(data => {
      return data
    },
      error => { // request level error
        return new Promise((resolve, reject) => {
          reject(error)
        })
      })
}

export const getInventoryLists = async (filters = {}) => {
  const { includeInactive, findDuplicate, categoryId, categoryFilter, manufacturerFilter, partNoFilter, search, offset, limit, type, sortBy } = filters;

  const params = {
    ...(includeInactive ? { includeInactive } : {}),
    ...(findDuplicate ? { findDuplicate: true } : {}),
    ...(categoryId ? { categoryId } : {}),
    ...(categoryFilter ? { categoryFilter } : {}),
    ...(manufacturerFilter ? { manufacturerFilter } : {}),
    ...(partNoFilter ? { partNoFilter } : {}),
    ...(search ? { search } : {}),
    ...(offset !== undefined ? { offset } : {}),
    ...(limit !== undefined ? { limit } : {}),
    ...(type ? { type } : {}),
    ...(sortBy ? { sortBy } : {}), // pass sortBy as 'item' or '-item'
  };

  return await axios('get', `${LIST_INVENTORY}`, {}, {
    server: microServices.DE_CORE,
    params,
  }).then(data => data)
    .catch(error => Promise.reject(error));
};

export const getInventoryListWithDuplicates = async (filters = {}) => {
  const { includeInactive, categoryId, categoryFilter, manufacturerFilter, partNoFilter, search, offset, limit, type, sortBy } = filters;

  const params = {
    ...(includeInactive ? { includeInactive } : {}),
    ...(categoryId ? { categoryId } : {}),
    ...(categoryFilter ? { categoryFilter } : {}),
    ...(manufacturerFilter ? { manufacturerFilter } : {}),
    ...(partNoFilter ? { partNoFilter } : {}),
    ...(search ? { search } : {}),
    ...(offset !== undefined ? { offset } : {}),
    ...(limit !== undefined ? { limit } : {}),
    ...(type ? { type } : {}),
    ...(sortBy ? { sortBy } : {}), // pass sortBy as 'item' or '-item'
  };

  return await axios('get', `${LIST_INVENTORY_DUPLICATES}`, {}, {
    server: microServices.DE_CORE,
    params,
  }).then(data => data)
    .catch(error => Promise.reject(error));
};

export const setBulkMaterialDuplicateVisibilityAPI = async (updates) => {
  return await axios('put', `${UPDATE_DUPLICATE_VISIBILITY}`, { updates }, {
    successMessage: 'Material changes saved successfully',
    server: microServices.DE_CORE
  }).then(data => data)
    .catch(error => Promise.reject(error));
};
export const moveItems = async (data) => {
  return await axios('post', MOVE_ITEMS, data, {
    server: microServices.DE_CORE
  }).then(data => data)
    .catch(error => Promise.reject(error));
};
export const suggestMaterialsAPI = async (params) => {
  return await axios('post', `${SUGGEST_MATERIALS}`,
    params,
    {
      server: microServices.DE_CORE
    }
  ).then(data => {
    return data;
  }, error => {
    return new Promise((resolve, reject) => {
      reject(error);
    });
  });
};

export const countAffectedTemplatesAPI = async (params) => {
  return await axios('post', COUNT_AFFECTED_TEMPLATES, params, {
    server: microServices.DE_CORE
  }).then(data => {
    return data;
  }, error => {
    return new Promise((resolve, reject) => {
      reject(error);
    });
  });
};

export const massReplaceMaterialsAPI = async (params) => {
  return await axios('post', MASS_REPLACE_MATERIALS, params, {
    server: microServices.DE_CORE
  }).then(data => {
    return data;
  }, error => {
    return new Promise((resolve, reject) => {
      reject(error);
    });
  });
};

export const replaceAndHideMaterialsAPI = async (params) => {
  return await axios('post', REPLACE_AND_HIDE_MATERIALS, params, {
    server: microServices.DE_CORE
  }).then(data => {
    return data;
  }, error => {
    return new Promise((resolve, reject) => {
      reject(error);
    });
  });
};

export const getSwapAffectedCountAPI = async (params) => {
  return await axios('get', GET_SWAP_AFFECTED_COUNT, {}, {
    server: microServices.DE_CORE,
    params
  }).then(data => {
    return data;
  }, error => {
    return new Promise((resolve, reject) => {
      reject(error);
    });
  });
};

export const swapMaterialsAPI = async (params) => {
  return await axios('post', SWAP_MATERIALS, params, {
    server: microServices.DE_CORE,
    successMessage: 'Materials swapped successfully'
  }).then(data => {
    return data;
  }, error => {
    return new Promise((resolve, reject) => {
      reject(error);
    });
  });
};

export const getSwapMaterialsListAPI = async (params) => {
  return await axios('get', GET_SWAP_MATERIALS_LIST, {}, {
    server: microServices.DE_CORE,
    params
  }).then(data => {
    return data;
  }, error => {
    return new Promise((resolve, reject) => {
      reject(error);
    });
  });
};
